module.exports = __webpack_public_path__ + "static/media/cutsglare_simpchinese_00074.1e686266.png";


//////////////////
// WEBPACK FOOTER
// ./src/screens/hdpolarized/axis/sc/cutsglare_simpchinese_00074.png
// module id = 2897
// module chunks = 0